import theme from '@styles/theme';
import { keyframes } from '@emotion/react';
export const loaderAnimation = keyframes`
    0% {margin-left:-50%;}
    100% {margin-left:150%;}
`;
export default {
  preloaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 1,
    transition: `opacity ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`,
    width: '100%',
    height: '100%',
    minHeight: '100%',
    padding: '16px',
    border: 'none'
  },
  preloaderText: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: theme.rawColors.darkGrey700,
    marginBottom: '16px'
  },
  preloader: {
    width: '100%',
    height: '4px',
    backgroundColor: theme.rawColors.darkGrey300,
    overflow: 'hidden',
    '&::after': {
      content: '""',
      display: 'block',
      width: '50%',
      height: '100%',
      backgroundColor: theme.rawColors.darkGrey700,
      animation: `${loaderAnimation} 1.2s linear infinite`
    }
  }
};